<script setup lang="ts">
import verifiedTickImg from '@assets/images/verified-step-tick.png'
</script>

<template>
  <div class="ati__circle">
    <img :src="verifiedTickImg" alt="Success" class="ati__img" />
  </div>
</template>

<style scoped>
.ati__circle {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: linear-gradient(166deg, #00614d 41.7%, #00372d 92.35%);
  border: 1px solid #02ebac;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  animation: ati-pop 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.05s both;
}

.ati__circle::before,
.ati__circle::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid rgba(2, 235, 172, 0.5);
  animation: ati-ripple 1.8s ease-out 0.3s infinite;
}

.ati__circle::after {
  border-color: rgba(2, 235, 172, 0.25);
  animation-delay: 0.75s;
}

.ati__img {
  width: 70px;
  height: 70px;
  object-fit: contain;
}

@keyframes ati-pop {
  0% {
    transform: scale(0.4);
    opacity: 0;
  }
  60% {
    transform: scale(1.15);
    opacity: 1;
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes ati-ripple {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
</style>
